import { Entity } from "../helpers/Entity"

export type CustomFieldAttributesDto = {
    name: string
    fieldType: string
    metadata: object
    availableFrom: string
    accountId: string
    createdBy: string
    createdAt: Date
    updatedAt: Date
    updatedBy: string
}

export type CustomFieldDto = {
    attributes: CustomFieldAttributesDto
    id: string
    type: string
}

export default class CustomField implements Entity {
    dto: CustomFieldDto
    constructor(dto: CustomFieldDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "custom-field-definitions"
    }

    getId(): string {
        return this.dto.id
    }

    isAvailableForObjectType(objectType: string): boolean {
        const includesAll = this.dto.attributes.availableFrom == null
        return includesAll || this.dto.attributes.availableFrom.includes(objectType)
    }

    isAvailable(supportedObjectTypes: string[]): boolean {
        if (supportedObjectTypes.length === 0) {
            return true
        }

        if (!this.dto.attributes.availableFrom) {
            return true
        }

        for (const supportedObjectType of supportedObjectTypes) {
            for (const availableFromObjectType of this.dto.attributes.availableFrom) {
                if (availableFromObjectType === supportedObjectType) {
                    return true
                }
            }
        }
        return false
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getFieldType(): string {
        return this.dto.attributes.fieldType
    }
}


// WEBPACK FOOTER //
// ./src/state/custom-fields/CustomField.ts